import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import * as cartSlice from "../store/cart"
import * as productApis from "../utilities/apis/product"
import { url } from "../utilities/enumerations/constants"

const HomeProducts = ({ searchable }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const cartState = useSelector((state) => state.cart)
  const [allProducts, setAllProducts] = useState([])
  const [products, setProducts] = useState([])
  const [search, setSearch] = useState("")

  const handleView = (slug) => {
    navigate(`/products/${slug}`)
  }

  const handleCart = async (e, product) => {
    e.stopPropagation()
    dispatch(cartSlice.addToCart({ ...product, type: "product" }))
  }

  const handleDecrement = async (e, slug) => {
    e.stopPropagation()
    dispatch(cartSlice.handleCartDecrement(slug))
  }

  const handleIncrement = async (e, slug) => {
    e.stopPropagation()
    if (cartState.cartById[slug] >= 10) return alert('For more than 5 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleCartIncrement(slug))
  }

  const getProducts = async () => {
    try {
      const response = await productApis.getHomeProducts()
      if (!response.status) throw new Error(response.message)

      setAllProducts(response.products)
      setProducts(response.products)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getProducts()
  }, [])

  useEffect(() => {
    setProducts(allProducts.filter((product) => product.title.toLowerCase().indexOf(search.toLowerCase()) > -1 || product.slug.toLowerCase().indexOf(search.toLowerCase()) > -1))
  }, [search])

  if (!allProducts.length) return null

  return (
    <section id="products" className="py-3 py-sm-4 py-lg-5">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-3 mb-sm-4 mb-lg-5">
          <h1 className="text-body-emphasis fw-bold m-0">Products</h1>
          {!searchable && <Link to="/products">Explore All Products</Link>}
          {searchable && <input type="text" className="form-control w-25" placeholder="Type title or sku to search a products" value={search} onChange={(e) => setSearch(e.target.value)} />}
        </div>

        <div className="row g-3 g-xl-2">
          {products.map((product) => {
            let src = "/upload.png"
            if (product.thumbnail) src = product.thumbnail
            if (product.thumbnail_url) src = product.thumbnail_url.replace("public", url)

            return (
              <div key={product.id.toString()} className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                <div onClick={() => handleView(product.slug)} className="card shadow-none text-dark p-1">
                  <img src={src} className="card-img-top img-fluid deal-image" alt={product.title} />
                  <div className="card-body p-1 d-flex flex-column gap-2">
                    <p className="fw-bold m-0 text-truncate">{product.title}</p>
                    <p className="text-theme fw-bold m-0">Rs. {product.price.toFixed(2)}</p>
                    {
                      !cartState.cartById[product.slug]
                        ? <button className="btn btn-sm btn-light-theme w-100" onClick={(e) => handleCart(e, product)}>Add to Cart</button>
                        : <div className="d-flex gap-3 justify-content-between align-items-center">
                          <button type="button" className="btn btn-sm btn-light-theme flex-grow-1" onClick={(e) => handleDecrement(e, product.slug)}><i className="bi bi-dash-lg"></i></button>
                          <p className="flex-grow-1 fs-5 text-muted text-center fw-bold m-0">{cartState.cartById[product.slug]}</p>
                          <button type="button" className="btn btn-sm btn-light-theme flex-grow-1" onClick={(e) => handleIncrement(e, product.slug)}><i className="bi bi-plus-lg"></i></button>
                        </div>
                    }
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default HomeProducts